import { render, staticRenderFns } from "./pt.vue?vue&type=template&id=1c88b43c&scoped=true&lang=html&"
import script from "./pt.vue?vue&type=script&lang=js&"
export * from "./pt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c88b43c",
  null
  
)

export default component.exports